import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router, RouterOutlet} from '@angular/router';
import {MenuService} from '../../../services/menu-services';
import {NgForOf, NgIf} from '@angular/common';
import {Card, CardsArray, ImageCardsMenuArray, PremiumCareCards} from '../../../model/cards';
import {HeaderMenu, Menu} from '../../../model/menu';
import {TextsComponent} from '../texts/texts.component';
import {Text} from '../../../model/text';
import {LoopedSliderComponent} from '../looped-slider/looped-slider.component';
import {ThemeService} from '../../../services/theme.service';
import {MenuElements} from '../../../model/menuEl';
import {MenuVerticalSliderComponent} from '../menu-vertical-slider/menu-vertical-slider.component';
import {ContinentService} from '../../../services/continent-service';
import {PaginationParams} from '../../../model/pagination';
import {environment} from '../../../environments/environment';
import {AdventuresService} from '../../../services/adventures-service';
import {ServicesArray} from '../../../model/services';
import {LocationDto} from '../../../model/continent';
import {scrollUp} from '../../../functions/scroll-up';

class MenuEls {
  img: string = '';
  title: Text[] = [];
  url: string = '';

  constructor(data: MenuEls) {
    this.img = data.img ?? '';
    this.title = data.title ?? [];
    this.url = data.url ?? '';
  }
}

@Component({
  selector: 'app-menu',
  imports: [
    NgIf,
    NgForOf,
    TextsComponent,
    LoopedSliderComponent,
    MenuVerticalSliderComponent
  ],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss'
})
export class MenuComponent implements OnInit {
  @ViewChild(RouterOutlet) outlet: RouterOutlet | undefined;
  constructor(protected menuService: MenuService,
              private route: ActivatedRoute,
              private router: Router,
              public themeService: ThemeService,
              protected continentService: ContinentService,
              protected adventuresService: AdventuresService,) {}


  scrollTimeout: any;
  // openOverlay: boolean = true;
  menuEls: MenuEls[] = [
    {
      img: '/app/assets/images/mobileMenu/destinations.jpg',
      title: [{text: ['Направления', 'Destinations']}],
      url: '/destinations'
    },
    {
      img: '/app/assets/images/mobileMenu/services.jpg',
      title: [{text: ['сервисы', 'services']}],
      url: '/services'
    },
    {
      img: '/app/assets/images/mobileMenu/adventures.jpg',
      title: [{text: ['путешествия', 'adventures']}],
      url: '/adventures'
    },
    {
      img: '/app/assets/images/mobileMenu/vip.jpg',
      title: [{text: ['VIP in Airports', 'VIP in Airports']}],
      url: '/feedback'
    },
  ];
  menuOverlayList: Text[][] = [
    // [{text: ['Главная', 'Main']},],
    [{text: ['О нас', 'About']},],
    [{text: ['Направления', 'Destinations']},],
    [{text: ['сервисы', 'services']},],
    [{text: ['путешествия', 'adventures']},],
    [{text: ['VIP in Airports', 'VIP in Airports']}]
  ];
  menuOverlayListActive: Text[][] = [
    // [{text: ['Главная', 'Main'], fontFamily: 'pd', fontStyle: 'italic'},],
    [{text: ['О нас', 'About'], fontFamily: 'pd', fontStyle: 'italic'},],
    [{text: ['Направления', 'Destinations'], fontFamily: 'pd', fontStyle: 'italic'},],
    [{text: ['сервисы', 'services'], fontFamily: 'pd', fontStyle: 'italic'},],
    [{text: ['путешествия', 'adventures'], fontFamily: 'pd', fontStyle: 'italic'},],
    [{text: ['VIP in Airports', 'VIP in Airports'], fontFamily: 'pd', fontStyle: 'italic'}]
  ]


  scrollTop: number = 0;
  heightScreen: number = 0;
  coefficient: number = 200;
  grid: number = 3.4;

  menu: Menu[] = HeaderMenu;

  activeSection: number = 0;
  isMobile: boolean = false;

  labels: {label: Text[]}[] = [
    {
      label: [
        {text: ['Since 2015, we create ', 'Since 2015, we create ']},
        {text: ['unique ', 'unique '], fontFamily: 'pd', fontStyle: 'italic'},
        {text: ['experiences ', 'experiences ']},
      ]
    },
    {
      label: [{text: ['Antarctica', 'Antarctica'], fontFamily: 'pd', fontStyle: 'italic' }]
    },
    {
      label: [{text: ['Азия', 'Asia'], fontFamily: 'pd', fontStyle: 'italic' }]
    },
    {
      label: [{text: ['Австралия & Океания', 'Australia & Oceania'], fontFamily: 'pd', fontStyle: 'italic' }]
    },
    {
      label: [{text: ['Европа', 'Europe'], fontFamily: 'pd', fontStyle: 'italic' }]
    },
    {
      label: [{text: ['Ближний Восток', 'Middle East'], fontFamily: 'pd', fontStyle: 'italic' }]
    },
    {
      label: [{text: ['Северная Америка', 'North America'], fontFamily: 'pd', fontStyle: 'italic' }]
    },
    {
      label: [
        {text: ['Yacht ', 'Yacht '],  },
        {text: ['Rental ', 'Rental '], fontFamily: 'pd', fontStyle: 'italic'},
      ]
    },
    {
      label: [
        {text: ['Adventure  ', 'Adventure  '],  },
      ]
    },
    {
      label: [
        {text: ['Business lounges  ', 'Business lounges  '],  },
      ]
    },
  ];

  elements: MenuElements[] = [
    {
      blocks: [
        {
          anotherType: true,
          type: 'about',
        },
      ]
    },
    {
      blocks: [
        {
          title: [{text: ['Antarctica', 'Antarctica'], fontFamily: 'pd', fontStyle: 'italic' }],
          img: '/app/assets/images/continents/antarctica.jpeg'
        },
        {
          title: [{text: ['Азия', 'Asia'], fontFamily: 'pd', fontStyle: 'italic' }],
          img: '/app/assets/images/asia.png'
        },
        {
          title: [{text: ['Австралия & Океания', 'Australia & Oceania'], fontFamily: 'pd', fontStyle: 'italic' }],
          img: '/app/assets/images/australia.jpg'
        },
        {
          title: [{text: ['Европа', 'Europe'], fontFamily: 'pd', fontStyle: 'italic' }],
          img: '/app/assets/images/europe.jpg'
        },
        {
          title: [{text: ['Ближний Восток', 'Middle East'], fontFamily: 'pd', fontStyle: 'italic' }],
          img: '/app/assets/images/middle-east.png'
        },
        {
          title: [{text: ['Северная Америка', 'North America'], fontFamily: 'pd', fontStyle: 'italic' }],
          img: '/app/assets/images/north-america.jpg'
        },
      ]
    },
  ];

  continentsDto: LocationDto[] = [];
  servicesDto: LocationDto[] = [];
  adventuresDto: LocationDto[] = [];
  vipsDto: LocationDto[] = [];

  continentCards: Card[] = [];
  servicesCards: Card[] = [];
  adventuresCards: Card[] = [];
  vipsCards: Card[] = [];

  arrays: LocationDto[][] = [];

  defaultParams = new PaginationParams({
    sort: 'titleEn:ASC',
    query: '',
    pageSize: 50,
    pageNumber: 0,
  });

  loading = false;


  @ViewChild('scrollableContainer') scrollableContainer!: ElementRef;

  onScroll(event: Event) {
    const target = event.target as HTMLElement;
    this.scrollTop = target.scrollTop;
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
    this.scrollTimeout = setTimeout(() => {
      this.onScrollEnd();
    }, 200);
  }

  getMobileBackground() {
    return `background-image: url("${this.menuEls[this.activeSection - 1].img}");`
  }

  openCase(idx: number) {
    this.menuService.setMobileOverlay(false);
    this.activeSection = idx;
  }

  getActiveScreen() {
    return Math.round((this.scrollTop + (this.scrollTop * 0.15)) / this.heightScreen * 0.9);
  }

  onScrollEnd() {
    const pos = this.getActiveScreen();
    const targetPosition = pos * this.heightScreen;
    this.scrollableContainer?.nativeElement?.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  }


  goTo(i: number) {
    this.menuService.setMobileListMenu(false);
    this.activeSection = i;
  }

  ngOnInit() {
    if (window.innerWidth < 769) {
      this.isMobile = true;
      if (window.innerWidth < 456) {
        this.grid = 1.3;
      } else {
        this.grid = 2.1;
      }
      this.heightScreen = window.innerHeight;
      this.labels = [
        {
          label: [
            {text: ['Since 2015, we create ', 'Since 2015, we create ']},
            {text: ['unique ', 'unique '], fontFamily: 'pd', fontStyle: 'italic'},
            {text: ['experiences ', 'experiences ']},
          ]
        },
        {
          label: [{text: ['Antarctica', 'Antarctica']}]
        },
        {
          label: [{text: ['Азия', 'Asia']}]
        },
        {
          label: [{text: ['Австралия & Океания', 'Australia & Oceania']}]
        },
        {
          label: [{text: ['Европа', 'Europe']}]
        },
        {
          label: [{text: ['Ближний Восток', 'Middle East']}]
        },
        {
          label: [{text: ['Северная Америка', 'North America'] }]
        },
        {
          label: [
            {text: ['Yacht ', 'Yacht ']},
            {text: ['Rental ', 'Rental ']},
          ]
        },
        {
          label: [
            {text: ['Adventure  ', 'Adventure  '],  },
          ]
        },
        {
          label: [
            {text: ['Business lounges  ', 'Business lounges  '],  },
          ]
        },
      ];
    } else {
      this.heightScreen = window.innerHeight * 0.70;
    }
    this.coefficient = this.heightScreen / 2;
    this.getData();
  }

  getData() {
    this.loading = true;
    this.continentService.getContinentList(this.defaultParams).subscribe((data) => {
      this.continentsDto = data.content ?? [];
      this.continentsDto.forEach((v) => {
        v.button = true;
      })
      this.continentCards = (this.continentsDto).map(v => {
        const path = v.image ? (environment.s3Prefix + v.image) : '/app/assets/images/hotel.png';
        let link: string | null;
        if (v.city?.country?.continent?.url.length != undefined && v.city?.country?.url != undefined) {
          link = v.city?.country?.continent?.url + '/' + v.city?.country?.url + '/' +
            v.city?.url + '/' + v?.url;
        } else {
          link = null
        }
        return new Card(
          {
            title: [v.titleRu, v.titleEn],
            text: ['', ''],
            img: path,
            style: v.cssStyleImage ?? '',
            link: '',
          },
        )
      });
      this.adventuresService.getAdventureList(this.defaultParams).subscribe((data) => {
        this.adventuresDto = data.content ?? [];
        this.adventuresDto.forEach((adventure) => {
          adventure.button = true;
        })
        this.adventuresCards = (this.adventuresDto ?? []).map(v => {
          const path = v.image ? (environment.s3Prefix + v.image) : '/app/assets/images/hotel.png';
          let link: string | null;
          if (v.city?.country?.continent?.url.length != undefined && v.city?.country?.url != undefined) {
            link = v.city?.country?.continent?.url + '/' + v.city?.country?.url + '/' +
              v.city?.url + '/' + v?.url;
          } else {
            link = null
          }
          return new Card(
            {
              title: [v.titleRu, v.titleEn],
              text: ['', ''],
              img: path,
              style: v.cssStyleImage ?? '',
              link: '',
            },
          )
        })
        this.servicesDto = (ServicesArray).map(v => {
          let titleRu: string = '';
          let titleEn: string = '';
          let style: string = '';
          if (v.title?.[0]?.text?.[0] != undefined) {
            titleRu = v.title[0].text[0];
          }
          if (v.title?.[0]?.text?.[1] != undefined) {
            titleEn = v.title[0].text[1];
          }
          if (v.filter !== undefined && v.filter && v.filterNumber === undefined) {
            style = `filter: grayscale(100%);`
          }
          if (v.filter !== undefined &&
              v.filter &&
              v.filterNumber !== undefined &&
              v.filterNumber > 0) {
            style = `filter: grayscale(${v.filterNumber}%);`
          }
          return new LocationDto({
            url: '',
            link: '',
            points: [],
            carousels: [],
            events: [],
            additionalEvents: [],
            titleEn: titleEn,
            titleRu: titleRu,
            descriptionEn: '',
            descriptionRu: '',
            image: v.img,
            orderNumber: 0,
            titleNatural: '',
            cssStyleImage: style,
            adventures: [],
            version: 0,
            button: true,
            getCountryLink: function() {
              return ''
            }
          });

        });
        this.servicesDto.forEach((v) => {
          v.front = true
          v.button = true;
        })
        this.servicesCards = (ServicesArray).map(v => {
          let title: string[] = [];
          let style: string = '';
          if (v.title[0].text != undefined) {
            title = v.title[0].text;
          }
          if (v.filterNumber !== undefined &&
            v.filterNumber > 0) {
            style = `filter: grayscale(${v.filterNumber}%);`
          }
          if (v.filter !== undefined &&
            v.filter && v.filterNumber == undefined) {
            style = `filter: grayscale(100%);`
          }
          return new Card(
            {
              title: title,
              text: ['', ''],
              img: v.img,
              style: style,
              link: '',
            },
          )
        })
        this.vipsDto = (PremiumCareCards).map(v => {
          let titleRu: string = '';
          let titleEn: string = '';
          if (v.title[0] != undefined) {
            titleRu = v.title[0];
          }
          if (v.title[1] != undefined) {
            titleEn = v.title[1];
          }
          return new LocationDto({
            url: '',
            link: '/feedback',
            points: [],
            carousels: [],
            events: [],
            additionalEvents: [],
            titleEn: titleEn,
            titleRu: titleRu,
            descriptionEn: '',
            descriptionRu: '',
            image: v.img,
            orderNumber: 0,
            titleNatural: '',
            cssStyleImage: v.style,
            adventures: [],
            version: 0,
            button: true,
            getCountryLink: function() {
              return ''
            }
          })
        })
        this.vipsDto.forEach((v) => {
          v.front = true
          v.button = true;
        });
        this.vipsCards = PremiumCareCards;
        this.arrays = [
          this.continentsDto,
          this.servicesDto,
          this.adventuresDto,
          this.vipsDto
        ];
      })
      this.loading = false;
    });
  }

  getArrayCards(index: number) {
    switch (index) {
      case 0: return [];
      case 1: return this.continentCards;
      case 2: return this.servicesCards;
      case 3: return this.adventuresCards;
      case 4: return this.vipsCards;
      default: return [];
    }
  }

  getArrayLocations(index: number) {
    switch (index) {
      case 0: return [];
      case 1: return this.continentsDto;
      case 2: return this.servicesDto;
      case 3: return this.adventuresDto;
      case 4: return this.vipsDto;
      default: return [];
    }
  }

  openUrl(index?: number) {
    if (index !== undefined) {
      if (index === 0) {
        this.menuService.setMobileOverlay(false);
      } else {
        scrollUp();
        this.router.navigate([ this.menuEls[index - 1].url ]).then(r => r);
        this.menuService.setActive();
      }
    }
  }

  getUrlPathSegments(): string[] {
    const fullUrl = window.location.href;
    const origin = window.location.origin;
    const pathUrl = fullUrl.startsWith(origin) ? fullUrl.substring(origin.length) : fullUrl;
    const trimmedPath = pathUrl.replace(/^\/+|\/+$/g, '');
    const parts = trimmedPath.split('/');
    return parts.filter(part => part.length > 0);
  }

  getActivePage() {
    const urls = this.getUrlPathSegments();
     if (urls.length == 0) {
       return 0;
     }
    if (urls[0] == 'destinations') {
      return 1;
    }
    if (urls[0] == 'services') {
      return 2;
    }
    if (urls[0] == 'adventures') {
      return 3;
    }
    if (urls[0] == 'feedback') {
      return 4;
    }
    return 0;
  }

  goToHome() {
    scrollUp();
    this.menuService.setActive(false);
    this.router.navigate([ '/' ]).then(r => r);
  }

  protected readonly ImageCardsMenuArray = ImageCardsMenuArray;
  protected readonly CardsArray = CardsArray;
}
